import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
    padding-inline: 24px;
  }
`;

export const LeftColumn = styled.div`
  width: 348px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const RightColumn = styled.div`
  flex: 1 1 auto;
`;
